module.exports = __webpack_public_path__ + "media/images/emblems/BrusinoArsizio-coat_of_arms-bf40fbcbcc150547210426d2d541eea2.svg";